/* src/app/otp-page/newpassword/newpassword.component.scss */
.popup-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f9fafb;
  overflow-y: auto;
  height: 100%;
}
.popup-content {
  background: #fff;
  padding: 30px;
  border-radius: 12px;
  width: 400px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.popup-content p {
  margin-bottom: 30px;
}
.form-group {
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
}
label {
  font-weight: 500;
  margin-bottom: 8px;
  text-align: left;
}
.styled-input {
  padding: 0.75rem 1rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
  outline: none;
  transition: border 0.3s ease;
}
.styled-input:hover {
  border-color: orange !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF !important;
}
.styled-input:focus {
  border-color: orange !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF !important;
}
.text-danger {
  color: #d93025;
  font-size: 13px;
  margin-top: 4px;
  text-align: left;
}
.button-group {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
.btn {
  width: 100%;
  justify-content: center;
}
/*# sourceMappingURL=newpassword.component-FZ6ZT52G.css.map */
